import React from 'react';

export interface ApprovalField {
  key: string;
  label?: string;
  secret?: boolean;
  placeholder?: string;
  value?: string;
}

export const ApprovalInputs: React.FC<{
  fields: ApprovalField[];
  values: Record<string, string>;
  disabled?: boolean;
  onChange: (values: Record<string, string>) => void;
}> = ({ fields, values, disabled, onChange }) => (
  <div className="approval-inputs">
    {fields.map((field) => (
      <label key={field.key}>
        <span>
          {field.label || field.key}
          {field.secret ? ' (kept secret)' : ''}
        </span>
        <input
          type={field.secret ? 'password' : 'text'}
          autoComplete="off"
          disabled={disabled}
          placeholder={field.placeholder}
          value={values[field.key] ?? field.value ?? ''}
          onChange={(event) =>
            onChange({ ...values, [field.key]: event.target.value })
          }
        />
      </label>
    ))}
  </div>
);
